import React from 'react';
import Button from "../../../../../core/components/button";

export default function StepButton({content}) {
    return (
        <div className={'grid md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4'}>
            <Button onClick={() => window.open(content?.content, '_blank')}>
                {content?.title}
            </Button>
        </div>
    );
}